import axios from 'axios';
import { loader } from '../../../layout/loader';

export default class CropHandler {
    constructor(ref, filterName, settings = null) {
        this.ref = ref;
        this.filterName = filterName;
        this.route = null;
        this.settings = settings;
    }

    setLoaderVisibility(value, response) {
        if (window.loader !== undefined) {
            value ? loader.show() : loader.hide(response);
        }
    }

    generateGetRoute() {
        if (window.fos === undefined) {
            this.route = `http://localhost:9009/${this.filterName}`;
        } else {
            this.route = Routing.generate('reborn_media.get_crop_data', {
                reference: this.ref,
                filter_name: this.filterName,
            });
        }
    }

    generatePostRoute() {
        if (window.fos === undefined) {
            this.route = `http://localhost:9009/${this.filterName}`;
        } else {
            this.route = Routing.generate('reborn_media.post_crop_filter', {
                ref: this.ref,
                filter_name: this.filterName,
            });
        }
    }

    getValues(callbackFunc) {
        const _this = this;
        this.generateGetRoute();
        this.setLoaderVisibility(true);
        axios.get(this.route)
            .then((response) => {
                _this.setLoaderVisibility(false);
                const { height, width, left, top, ratio } = response.data.settings;
                const settings = {
                    x: left === null ? 0 : left,
                    y: top === null ? 0 : top,
                    width: width === null ? 0 : width,
                    height: height === null ? 0 : height,
                    aspect: ratio === null ? 1 : ratio,
                };
                // Pass settings to callback function
                callbackFunc(settings);
            })
            .catch((response) => {
                _this.setLoaderVisibility(false, response);
                console.log(response);
                console.log('catched error');
            });
    }

    parseSettingsForPost() {
        const parsedSettings = {
            left: this.settings.x,
            top: this.settings.y,
            ratio: this.settings.aspect,
            width: this.settings.width,
            height: this.settings.height,
        };
        this.setSettings(parsedSettings);
    }
    setSettings(settings) {
        this.settings = settings;
    }
    postCrop(settings, callbackFunc) {
        const _this = this;
        this.generatePostRoute();
        this.parseSettingsForPost();
        this.setLoaderVisibility(true);
        axios.post(this.route, {
            settings: this.settings,
        })
            .then(function (response) {
                _this.setLoaderVisibility(false, response);
                callbackFunc(response.data, settings);
                // Pass settings to callback function
            })
            .catch(function (response) {
                _this.setLoaderVisibility(false);
                console.log('error');
            });
    }

    update(ref, filter, settings) {
        this.ref = ref;
        this.filterName = filter;
        this.settings = settings;
    }
}


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/helpers/CropHandler.js